import { render, staticRenderFns } from "./StorageLocationChange.vue?vue&type=template&id=5c3e5aec&scoped=true"
import script from "./StorageLocationChange.vue?vue&type=script&setup=true&lang=js"
export * from "./StorageLocationChange.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3e5aec",
  null
  
)

export default component.exports